import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './module/home/home.component';
import { LoginComponent } from './module/auth/login/login.component';
import { authGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  { path: 'home', component: HomeComponent, canActivate: [authGuard] },

  { path: 'login', component: LoginComponent },

  // Cadastro
  {
    path: 'cadastro',
    loadChildren: () =>
      import('./module/cadastro/cadastro.module').then((m) => m.CadastroModule),
    canActivate: [authGuard],
  },

  // Apoio
  {
    path: 'apoio',
    loadChildren: () =>
      import('./module/apoio/apoio.module').then((m) => m.ApoioModule),
    canActivate: [authGuard],
  },

  // Segurança
  {
    path: 'seguranca',
    loadChildren: () =>
      import('./module/seguranca/seguranca.module').then(
        (m) => m.SegurancaModule
      ),
    canActivate: [authGuard],
  },

  // Relatorio
  {
    path: 'relatorio',
    loadChildren: () =>
      import('./module/relatorio/relatorio.module').then(
        (m) => m.RelatorioModule
      ),
    canActivate: [authGuard],
  },

  // Consulta
  {
    path: 'consulta',
    loadChildren: () =>
      import('./module/consulta/consulta.module').then((m) => m.ConsultaModule),
    canActivate: [authGuard],
  },

  // Conciliacao
  {
    path: 'conciliacao',
    loadChildren: () =>
      import('./module/conciliacao/conciliacao.module').then((m) => m.ConciliacaoModule),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
